import React from "react";
import { useSelector } from "react-redux";
import { getShowSiteSelectionModal } from "../store/siteInfoSlice";
import { getShowForgotPassword, getShowLockFeature, getShowLogin, getShowRegister } from "../store/userSlice";
import ImageLightbox from './lightbox';
import TaskDiscardAlertModal from './modals/discard-task-text/discard-task-modal';
import LockFeatureModal from './modals/lock-feature/lock-feature-modal';
import { LoginRegisterModal } from "./modals/login-register/login-register-modal";
import RegisterCompanyDetailsModal from './modals/Register-company-details/register-company-detail-modal';
import { SiteSelectionModal } from './modals/site-selection-modal';
import GodaddyNameModal from './modals/update-username/update-godaddy-username';
import UpdateUsernameModal from './modals/update-username/update-username';
// import { usePluginActivationRedirect } from "../hooks/use-activate-plugin";


function ActivationUI() {

    const showForgot = useSelector(getShowForgotPassword);
    const showLogin = useSelector(getShowLogin);
    const showRegister = useSelector(getShowRegister);
    const showSiteSelection = useSelector(getShowSiteSelectionModal);
    const showLockFeature = useSelector(getShowLockFeature);

    // const {showCollabExperience} = usePluginActivationRedirect()

    return (
        <div
            id="atarim-collab-app"
            className="relative w-full h-full isolate"
            data-atarim
        >

            {/* Modals */}
            {(showForgot || showLogin || showRegister) && <LoginRegisterModal />}
            {showSiteSelection && <SiteSelectionModal />}
            <RegisterCompanyDetailsModal />
            <ImageLightbox />
            <UpdateUsernameModal />
            <GodaddyNameModal />
            {showLockFeature && <LockFeatureModal />}
            <TaskDiscardAlertModal />
        </div>
    )
}

export default ActivationUI